export const formatPublishDate = (publishDate: string): string => {
  const date = new Date(publishDate);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const getTimeAgo = (publishDate: string): string => {
  const date = new Date(publishDate);
  const now = new Date();
  const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));
  return diffInHours < 24 ? `${diffInHours}h` : `${Math.floor(diffInHours / 24)}d`;
};
